import { drybulkCargoOperationsService } from "@services/drybulkCargoOperationsApi";
import { DRYBULK_CARGO_OPS_QUERY_KEYS } from "../constants";

export const gradeOptionsQuery = {
  queryKey: DRYBULK_CARGO_OPS_QUERY_KEYS.options("grades"),
  queryFn: () => drybulkCargoOperationsService.getGrades(),
  staleTime: Infinity,
  refetchOnWindowFocus: false,
  retry: false,
};
